export default __webpack_public_path__ + "static/media/facebook-logo.fe68b242.png";